import { createFeatureSelector, createSelector } from '@ngrx/store';
import { brandFeatureKey, BrandState } from './brand-reducer';

export const getFilterBrandState =
  createFeatureSelector<BrandState>(brandFeatureKey);

export const getBrandState = createSelector(
  getFilterBrandState,
  (state: BrandState) => state
);
